<span class="flex w-fit items-center rounded bg-white">
  <span
    class="ag1-badge"
    [class]="
      getVariantConfig()?.badgeClass
        ? $safeNavigationMigration(getVariantConfig()?.badgeClass)
        : 'ag1-badge-' + color()
    "
  >
    <div class="flex items-center gap-1">
      @if (getVariantConfig()?.leadingIcon || leadingIcon()) {
        <svg-icon [src]="leadingIcon() || getVariantConfig()?.leadingIcon" />
      }

      <span>{{ label() }}</span>

      @if (getVariantConfig()?.trailingIcon || trailingIcon()) {
        <svg-icon [src]="trailingIcon() || getVariantConfig()?.trailingIcon" />
      }
    </div>
  </span>
</span>
